import { createContext, useContext, useEffect, useState } from "react";

const PrescriptionCartContext = createContext();

export function PrescriptionCartProvider({ children }) {
  const [items, setItems] = useState(() => {
    const saved = localStorage.getItem("prescriptionCart");

    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem("prescriptionCart", JSON.stringify(items));
  }, [items]);

  console.log('Items Pres:',items);

  const addItem = (item) => {
    setItems((prev) => [...prev, item]);
  };

  const removeItem = (index) => {
    setItems((prev) => prev.filter((_, i) => i !== index));
  };

  const clearCart = () => {
    setItems([]);

    localStorage.removeItem("prescriptionCart");
  };

  return (
    <PrescriptionCartContext.Provider
      value={{
        items,
        addItem,
        removeItem,
        clearCart,
      }}
    >
      {children}
    </PrescriptionCartContext.Provider>
  );
}

export function usePrescriptionCart() {
  return useContext(PrescriptionCartContext);
}
